import React from "react";
import projectImage from "../../asset/project image.png";
import { GoArrowUpRight } from "react-icons/go";
import { useGetAllProjectsQuery } from "../../Redux/getApi";
import { NavLink } from "react-router-dom";

const Projects = () => {
  const { data, error, isLoading, isFetching } = useGetAllProjectsQuery();
  return (
    <div>
      <div className="flex flex-col gap-10  lg:py-20 md:py-14 sm:py-10 py-8 xl:px-[5%] lg:px-[3%] md:px-[2%] px-[6%]">
        <div className="flex items-center md:flex-row flex-col gap-10">
          <div className={`flex-1 flex flex-col gap-3 `}>
            <p className="md:text-[1.3rem] text-[1rem] text-[#00643b] font-semibold uppercase">
              Featured Project
            </p>
            <h1 className="xl:text-[2.5rem] lg:text-[1.8rem] text-[1.6rem]  font-bold">
              Dedicated Bike Lane On Old Airport Road
            </h1>
            <p className="xl:text-[1.3rem] md:text-[1.1rem] text-[.95rem] text-[#7A7A7A]">
              The Bike lane project on old airport road, developed with
              Rawalpindi Development Authority RDA’s support and the vision of
              CM Punjab Maryam Nawaz Sharif, ensures a safe and convenient bike
              route for citizens of Rawalpindi.
            </p>
          </div>
          <div className="flex-1 flex md:justify-end justify-center">
            <img
              src={projectImage}
              className={`md:w-[85%] w-[90%] rounded-2xl `}
              alt=""
            />
          </div>
        </div>
      </div>
      <div className="flex flex-col items-center gap-5 xl:mb-20 lg:mb-14 md:mb-10 sm:mb-8 mb-6">
        <h1 className="xl:text-[2.5rem] lg:text-[1.8rem] text-[1.6rem]  font-bold text-center">
          Recent Projects
        </h1>
        <span className="xl:text-[1.3rem] md:text-[1.1rem] text-[.95rem] text-[#7A7A7A] text-center">
          Explore the Rawalpindi Development Authority's latest development
          projects
        </span>

        {isFetching || isLoading ? (
          <div className="grid lg:grid-cols-4 sm:grid-cols-3 grid-cols-2 w-full">
            <div className=" w-full bg-[#EFEFEF] animate-pulse aspect-[1/1.2] rounded-2xl"></div>
            <div className=" w-full bg-[#EFEFEF] animate-pulse aspect-[1/1.2] rounded-2xl"></div>
            <div className=" w-full bg-[#EFEFEF] animate-pulse aspect-[1/1.2] rounded-2xl"></div>
            <div className=" w-full bg-[#EFEFEF] animate-pulse aspect-[1/1.2] rounded-2xl"></div>
            <div className=" w-full bg-[#EFEFEF] animate-pulse aspect-[1/1.2] rounded-2xl"></div>
            <div className=" w-full bg-[#EFEFEF] animate-pulse aspect-[1/1.2] rounded-2xl"></div>
            <div className=" w-full bg-[#EFEFEF] animate-pulse aspect-[1/1.2] rounded-2xl"></div>
            <div className=" w-full bg-[#EFEFEF] animate-pulse aspect-[1/1.2] rounded-2xl"></div>
            <div className=" w-full bg-[#EFEFEF] animate-pulse aspect-[1/1.2] rounded-2xl"></div>
            <div className=" w-full bg-[#EFEFEF] animate-pulse aspect-[1/1.2] rounded-2xl"></div>
          </div>
        ) : (
          data &&
          (data?.projects?.length === 0 ? (
            <div className=" text-center w-full lg:text-[3rem] md:text-[2rem] text-[1.4rem] font-semibold text-[#000000]">
              No Project Found
            </div>
          ) : (
            <div className="grid lg:grid-cols-4 sm:grid-cols-3 grid-cols-2 ">
              {data?.projects?.map((p, i) => (
                <NavLink
                  to={`/project/${p?._id}`}
                  key={i}
                  className="w-full relative group overflow-hidden "
                >
                  <img
                    src={p?.coverImage?.imageUrl}
                    className=" xl:h-[30rem] md:h-[25rem] sm:h-[20rem] w-full object-cover group-hover:scale-150 transition-all duration-300"
                    alt=""
                  />
                  <span className=" absolute sm:bottom-4 bottom-3 sm:left-4 left-2 xl:text-[1.8rem] lg:text-[1.6rem] sm:text-[1.2rem] text-[.9rem] font-semibold capitalize text-white">
                    {p?.title}
                  </span>
                  <GoArrowUpRight className="xl:size-10 sm:size-8 size-6 absolute sm:top-6 top-3 sm:right-6 right-3 transition-opacity duration-500  md:p-2 p-1 border rounded-full border-white group-hover:border-[#00643b] bg-none group-hover:bg-[#00643b] cursor-pointer font-bold text-white " />
                </NavLink>
              ))}
            </div>
          ))
        )}

        {error && (
          <p className=" text-red-500 text-center md:text-[1rem] text-sm bg-red-100 p-2 rounded-lg">
            {error?.data?.message || error?.data?.error}
          </p>
        )}
      </div>
    </div>
  );
};

export default Projects;
